var map = {
	"./img/andalucia/cover.webp": 79868,
	"./img/basque-country/cover.webp": 31979,
	"./img/berlin/cover.webp": 99522,
	"./img/copenhagen/cover.webp": 71505,
	"./img/portugal/cover.webp": 47388,
	"./img/slovenia/cover.webp": 55502,
	"./img/turkey/cover.webp": 46125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37256;